export default __webpack_public_path__ + "media/images/logo_with_favicon-44cad371b771551c91e86a849e2fa8f1.png";